import React, {Component} from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";

class MasterLogistikMotorTypeModifying extends Component {
    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Tipe"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <ModifyingDDL
                                id="select_options_segmen_"
                                name="idSeries"
                                text="Series"
                                mandatory
                                errorMessage={this.props.errors.idSeries}
                                options={this.props.dataSeriesDDL}
                                value={
                                    this.props.controls && Object.keys(this.props.controls).length > 0
                                        ? {
                                            label: this.props.controls.idSeries.value.label,
                                            value: this.props.controls.idSeries.value.value,
                                        }
                                        : undefined
                                }
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />

                            <SimpleInput
                                id="input_text_tipe"
                                name="typeName"
                                label="Nama Tipe"
                                mandatory
                                errorMessage={this.props.errors.typeName}
                                value={this.props.controls.typeName.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
                />
                )
    }
}

export default withFormGroup(MasterLogistikMotorTypeModifying);

class ModifyingDDL extends Component {
    render() {
        return (
            <FlexView column hAlignContent="center" style={{flex: 1}}>
                <SimpleDDL
                    containerclassname="margin-botton-5px width width-full"
                    box="search"
                    isSearchable={true}
                    isClearable
                    options={this.props.options}
                    label={this.props.text}
                    {...this.props}
                />
            </FlexView>
        );
    }
}